<!-- Toast Messages -->
<p-toast
  data-testid="logical-warehouse-form-toast"
  position="top-right"
  [baseZIndex]="9999"
  [autoZIndex]="true"
  [life]="6000"
  [preventDuplicates]="false"
></p-toast>

<div
  data-testid="logical-warehouse-form-page"
  class="px-6 p-6 h-screen flex flex-col min-h-0 overflow-hidden"
>
  <div class="flex justify-between items-center mb-1">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ formConfig().title }}
    </h2>
    <div class="flex gap-3">
      @for (action of formConfig().headerActions; track action.action) {
        <app-button
          [testId]="'logical-warehouse-form-header-action-' + action.action"
          [label]="action.label"
          [icon]="action.icon"
          (emitOnClick)="onFormAction({ action: action.action })"
          [outlined]="action.outlined || false"
          [type]="action.severity || 'primary'"
          [disabled]="action.disabled || false"
          [loading]="action.loading || false"
        ></app-button>
      }
    </div>
  </div>
  <div>
    <div class="flex">
      <button
        data-testid="logical-warehouse-form-tab-basic"
        type="button"
        class="px-6 py-3 text-sm font-medium border-b-2 transition-colors"
        [class]="
          activeTab() === 'basic'
            ? 'border-blue-500 text-blue-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
        "
        (click)="setTab('basic')"
      >
        {{ "logical_warehouse.form.tabs.basic" | translate }}
      </button>
      <button
        data-testid="logical-warehouse-form-tab-structure"
        type="button"
        class="px-6 py-3 text-sm font-medium border-b-2 transition-colors"
        [class]="
          activeTab() === 'structure'
            ? 'border-blue-500 text-blue-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
        "
        (click)="setTab('structure')"
      >
        {{ "logical_warehouse.form.tabs.structure" | translate }}
      </button>
    </div>
  </div>

  <div class="flex-1 min-h-0 overflow-hidden">
    @if (activeTab() === "basic") {
      <app-add-form
        data-testid="logical-warehouse-form-add-form"
        [title]="''"
        [formFields]="formConfig().formFields"
        [headerActions]="[]"
        [sectionButtons]="formConfig().sectionButtons"
        [tableSections]="formConfig().tableSections"
        [editMode]="isEditMode()"
        [viewMode]="false"
        [initialData]="warehouseData()"
        [loading]="loading()"
        [height]="'100%'"
        (formAction)="onFormAction($event)"
        (sectionAction)="onSectionAction($event)"
        (formValueChanges)="onFormValueChanges($event)"
        (tableAction)="onTableAction($event)"
      >
      </app-add-form>
    } @else {
      <div class="flex flex-col h-full min-h-0">
        <div class="flex flex-col gap-2 mb-3 mt-2 ml-2">
          <h3 class="text-xl font-semibold text-gray-800">
            {{
              warehouseName() ||
                ("logical_warehouse.form.tabs.structure" | translate)
            }}
          </h3>
          <p-menu
            data-testid="logical-warehouse-form-structure-menu"
            #structureMenu
            [popup]="true"
            [model]="structureMenuItems()"
            styleClass="logical-structure-menu"
          ></p-menu>
          <app-button
            testId="logical-warehouse-form-add-structure-btn"
            [label]="'logical_warehouse.structure.add' | translate"
            [type]="'info'"
            [outlined]="false"
            (emitOnClick)="structureMenu.toggle($event)"
          ></app-button>
        </div>
        <div class="w-full h-full flex-1 min-h-0">
          <!-- Hiển thị dynamic rows cho tất cả root items -->
          @if (rootStructureRows().length > 0) {
            <!-- Hiển thị dynamic rows -->
            <div class="flex flex-col h-full overflow-y-auto">
              @for (row of rootStructureRows(); track row.rootItemId) {
                <div
                  class="flex items-stretch w-full min-w-full border-b border-gray-200 last:border-b-0 py-2"
                >
                  @for (
                    sidebar of getSidebarChainForRootItem(
                      row.rootItem,
                      row.type
                    );
                    track sidebar.type
                  ) {
                    <!-- Dynamic Sidebar -->
                    <div
                      class="w-64 border-r border-gray-200 bg-white sticky top-0 overflow-y-auto self-stretch"
                    >
                      <div class="px-2">
                        <h3 class="text-base font-semibold mb-4">
                          {{
                            "logical_warehouse.structure." + sidebar.type
                              | translate
                          }}
                        </h3>
                        <div class="space-y-1">
                          @for (item of sidebar.items; track item.id) {
                            <button
                              [attr.data-testid]="
                                'logical-warehouse-form-sidebar-item-' +
                                row.rootItemId +
                                '-' +
                                sidebar.type +
                                '-' +
                                item.id
                              "
                              type="button"
                              class="w-full text-left group flex items-center justify-between py-1 px-2 rounded-md transition-colors cursor-pointer border-none"
                              [ngClass]="
                                item.id === sidebar.selectedId
                                  ? 'bg-blue-50 text-blue-600 font-medium'
                                  : 'bg-transparent hover:bg-gray-100 text-gray-700'
                              "
                              (click)="
                                onSelectItemInRow(row, sidebar.type, item.id)
                              "
                              (contextmenu)="
                                onEditStructureInRow(
                                  $event,
                                  row,
                                  sidebar.type,
                                  item.id
                                )
                              "
                              [pTooltip]="tooltipText(item)"
                              tooltipPosition="top"
                              appendTo="body"
                            >
                              <span class="text-sm">{{ item.name }}</span>
                              <div class="flex items-center gap-1">
                                <button
                                  [attr.data-testid]="
                                    'logical-warehouse-form-sidebar-delete-' +
                                    row.rootItemId +
                                    '-' +
                                    sidebar.type +
                                    '-' +
                                    item.id
                                  "
                                  type="button"
                                  class="material-symbols-outlined flex-shrink-0 cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity border-none bg-transparent p-0"
                                  style="font-size: 16px; color: #ef4444"
                                  (click)="
                                    $event.stopPropagation();
                                    onDeleteStructureInRow(
                                      $event,
                                      row,
                                      sidebar.type,
                                      item.id
                                    )
                                  "
                                >
                                  delete
                                </button>
                                @if (hasChildren(item, sidebar.type)) {
                                  <span
                                    class="material-symbols-outlined flex-shrink-0 ml-2"
                                    [ngClass]="
                                      item.id === sidebar.selectedId
                                        ? 'text-blue-600'
                                        : 'text-gray-400'
                                    "
                                    style="font-size: 20px"
                                  >
                                    {{
                                      item.id === sidebar.selectedId
                                        ? "expand_more"
                                        : "chevron_right"
                                    }}
                                  </span>
                                }
                              </div>
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  <!-- Content area for this row -->
                  <div class="flex-1 p-2 overflow-y-auto h-full min-h-0 pt-0">
                    <div class="min-w-[300px] overflow-x-auto">
                      @if (getShelvesForRow(row).length > 0) {
                        <div class="mb-4">
                          <h3 class="text-base font-semibold">
                            {{
                              "logical_warehouse.structure.shelf" | translate
                            }}
                          </h3>
                        </div>

                        <div
                          class="border border-gray-200 rounded-lg bg-white p-4 flex flex-col min-h-0 mb-4"
                        >
                          <div class="flex justify-end gap-3 mb-4">
                            <app-button
                              [testId]="
                                'logical-warehouse-form-add-shelf-slot-btn-' +
                                row.rootItemId
                              "
                              [label]="
                                'logical_warehouse.structure.add_slot'
                                  | translate
                              "
                              [type]="'info'"
                              [outlined]="false"
                              [disabled]="
                                !selectedItemsByRow().get(row.rootItemId)
                                  ?.shelfId
                              "
                              (emitOnClick)="onAddBinFromButton()"
                            ></app-button>
                          </div>
                          <div class="space-y-4 flex-1 min-h-0 overflow-y-auto">
                            @for (
                              shelf of getShelvesForRow(row);
                              track shelf.id
                            ) {
                              <div
                                class="border rounded-lg"
                                [ngClass]="
                                  shelf.id ===
                                  selectedItemsByRow().get(row.rootItemId)
                                    ?.shelfId
                                    ? 'border-rose-200 bg-rose-50'
                                    : 'border-gray-200 bg-white'
                                "
                              >
                                <button
                                  [attr.data-testid]="
                                    'logical-warehouse-form-shelf-select-' +
                                    row.rootItemId +
                                    '-' +
                                    shelf.id
                                  "
                                  type="button"
                                  class="px-3 pb-3 grid grid-cols-[repeat(auto-fit,minmax(150px,150px))] gap-1.5 cursor-pointer border-none bg-transparent w-full text-left font-normal block"
                                  (click)="
                                    onSelectItemInRow(row, 'shelf', shelf.id)
                                  "
                                >
                                  <div
                                    class="group col-span-full px-3 py-2 text-sm font-semibold cursor-pointer flex items-center justify-between"
                                    [pTooltip]="tooltipText(shelf)"
                                    tooltipPosition="top"
                                    (contextmenu)="
                                      onEditStructureInRow(
                                        $event,
                                        row,
                                        'shelf',
                                        shelf.id
                                      )
                                    "
                                  >
                                    <span>{{ shelf.name }}</span>
                                    <button
                                      [attr.data-testid]="
                                        'logical-warehouse-form-shelf-delete-' +
                                        row.rootItemId +
                                        '-' +
                                        shelf.id
                                      "
                                      type="button"
                                      class="material-symbols-outlined flex-shrink-0 cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity border-none bg-transparent p-0"
                                      style="font-size: 16px; color: #ef4444"
                                      (click)="
                                        $event.stopPropagation();
                                        onDeleteStructureInRow(
                                          $event,
                                          row,
                                          'shelf',
                                          shelf.id
                                        )
                                      "
                                    >
                                      delete
                                    </button>
                                  </div>
                                  @for (slot of shelf.slots; track slot.id) {
                                    <button
                                      [attr.data-testid]="
                                        'logical-warehouse-form-bin-select-' +
                                        row.rootItemId +
                                        '-' +
                                        slot.id
                                      "
                                      type="button"
                                      class="group w-[150px] h-[60px] border rounded-md bg-gradient-to-br from-gray-50 to-gray-100 border-gray-300 shadow-sm hover:shadow-md hover:border-blue-400 cursor-pointer flex flex-col items-center justify-center p-1 transition-all relative font-normal"
                                      [ngClass]="
                                        slot.id ===
                                        selectedItemsByRow().get(row.rootItemId)
                                          ?.slotId
                                          ? 'border-amber-400 bg-gradient-to-br from-amber-50 to-amber-100 shadow-md'
                                          : ''
                                      "
                                      [pTooltip]="tooltipText(slot)"
                                      tooltipPosition="top"
                                      (click)="
                                        $event.stopPropagation();
                                        onEditStructureInRow(
                                          $event,
                                          row,
                                          'bin',
                                          slot.id
                                        )
                                      "
                                    >
                                      <span
                                        class="text-sm font-medium text-gray-700 truncate w-full text-center leading-tight"
                                        >{{ slot.name }}</span
                                      >
                                      <button
                                        [attr.data-testid]="
                                          'logical-warehouse-form-bin-delete-' +
                                          row.rootItemId +
                                          '-' +
                                          slot.id
                                        "
                                        type="button"
                                        class="material-symbols-outlined absolute top-0 right-0 cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity border-none bg-transparent p-0"
                                        style="font-size: 16px; color: #ef4444"
                                        (click)="
                                          $event.stopPropagation();
                                          onDeleteStructureInRow(
                                            $event,
                                            row,
                                            'bin',
                                            slot.id
                                          )
                                        "
                                      >
                                        delete
                                      </button>
                                    </button>
                                  }
                                </button>
                              </div>
                            }
                          </div>
                        </div>
                      }

                      @if (getRackDirectSlotsForRow(row).length > 0) {
                        <div class="mb-4">
                          <h3 class="text-base font-semibold">
                            {{ "logical_warehouse.structure.bin" | translate }}
                            <span
                              class="text-gray-500 font-normal text-xs ml-1"
                            >
                              ({{
                                "logical_warehouse.structure.direct_in_rack"
                                  | translate
                              }})
                            </span>
                          </h3>
                        </div>

                        <div
                          class="border border-gray-200 rounded-lg bg-white p-4 flex flex-col min-h-0 mb-4"
                        >
                          <div class="flex justify-end gap-3 mb-4">
                            <app-button
                              [testId]="
                                'logical-warehouse-form-add-rack-bin-btn-' +
                                row.rootItemId
                              "
                              [label]="
                                'logical_warehouse.structure.add_slot'
                                  | translate
                              "
                              [type]="'info'"
                              [outlined]="false"
                              (emitOnClick)="onAddBinToRackFromButton(row)"
                            ></app-button>
                          </div>
                          <div
                            class="grid grid-cols-[repeat(auto-fit,minmax(150px,150px))] gap-1.5 flex-1 min-h-0 overflow-y-auto"
                          >
                            @for (
                              slot of getRackDirectSlotsForRow(row);
                              track slot.id
                            ) {
                              <button
                                [attr.data-testid]="
                                  'logical-warehouse-form-rack-bin-select-' +
                                  row.rootItemId +
                                  '-' +
                                  slot.id
                                "
                                type="button"
                                class="group w-[150px] h-[60px] border rounded-md bg-gradient-to-br from-gray-50 to-gray-100 border-gray-300 shadow-sm hover:shadow-md hover:border-blue-400 cursor-pointer flex flex-col items-center justify-center p-1 transition-all relative font-normal"
                                [ngClass]="
                                  slot.id ===
                                  selectedItemsByRow().get(row.rootItemId)
                                    ?.slotId
                                    ? 'border-amber-400 bg-gradient-to-br from-amber-50 to-amber-100 shadow-md'
                                    : ''
                                "
                                [pTooltip]="tooltipText(slot)"
                                tooltipPosition="top"
                                (click)="
                                  $event.stopPropagation();
                                  onEditStructureInRow(
                                    $event,
                                    row,
                                    'bin',
                                    slot.id
                                  )
                                "
                              >
                                <span
                                  class="text-sm font-medium text-gray-700 truncate w-full text-center leading-tight"
                                  >{{ slot.name }}</span
                                >
                                <button
                                  [attr.data-testid]="
                                    'logical-warehouse-form-rack-bin-delete-' +
                                    row.rootItemId +
                                    '-' +
                                    slot.id
                                  "
                                  type="button"
                                  class="material-symbols-outlined absolute top-0 right-0 cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity border-none bg-transparent p-0"
                                  style="font-size: 16px; color: #ef4444"
                                  (click)="
                                    $event.stopPropagation();
                                    onDeleteStructureInRow(
                                      $event,
                                      row,
                                      'bin',
                                      slot.id
                                    )
                                  "
                                >
                                  delete
                                </button>
                              </button>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>

      <app-structure-dialog
        data-testid="logical-warehouse-form-structure-dialog"
        [visible]="showStructureDialog()"
        [type]="structureDialogType() || 'zone'"
        [isEdit]="structureDialogMode() === 'edit'"
        [initialData]="structureDialogInitialData()"
        [parentOptions]="structureDialogParentOptions()"
        [parentLabel]="structureDialogParentLabel()"
        [zoneOptions]="structureDialogZoneOptions()"
        [allAisleOptions]="structureDialogAllAisleOptions()"
        (visibleChange)="onStructureDialogVisibleChange($event)"
        (confirm)="onStructureDialogConfirm($event)"
      ></app-structure-dialog>
    }
  </div>
</div>

<app-confirmation-dialog
  data-testid="logical-warehouse-form-delete-confirmation-dialog"
  [visible]="showDeleteConfirmation()"
  [title]="deleteConfirmationTitle()"
  [message]="deleteConfirmationMessage()"
  [buttons]="[
    { label: 'common.actions.cancel', action: 'cancel', outlined: true },
    { label: 'common.actions.confirm', action: 'confirm', severity: 'danger' },
  ]"
  (emitOnClick)="onDeleteConfirmationAction($event)"
  (visibleChange)="showDeleteConfirmation.set($event)"
></app-confirmation-dialog>
